import React from "react";
import AppButton from "../../../../components/AppButton";
import AppInput from "../../../../components/AppInput";
import AppToolbar from "../../../../components/AppToolbar";
import {
  IconArrowLeft,
  IconArrowRight,
  IconDelete,
  IconEdit,
  IconExport,
  IconImport,
  IconRules,
} from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const actionGapRows = [
  {
    key: "xs",
    token: "--ds-action-gap-xs",
    value: "6px",
    actionSize: "XS-Actions",
    preview: (
      <>
        <AppButton size="xs" variant="neutral" iconOnly aria-label="Bearbeiten">
          <IconEdit />
        </AppButton>
        <AppButton size="xs" variant="neutral" iconOnly aria-label="Löschen">
          <IconDelete />
        </AppButton>
      </>
    ),
  },
  {
    key: "sm",
    token: "--ds-action-gap-sm",
    value: "8px",
    actionSize: "SM-Actions",
    preview: (
      <>
        <AppButton size="sm" variant="neutral">
          <IconArrowLeft />
          Zurück
        </AppButton>
        <AppButton size="sm" variant="primary">
          Weiter
          <IconArrowRight />
        </AppButton>
      </>
    ),
  },
  {
    key: "md",
    token: "--ds-action-gap-md",
    value: "12px",
    actionSize: "MD-Actions",
    preview: (
      <AppToolbar
        left={
          <>
            <div className="ds-table-toolbar__search">
              <AppInput type="search" size="md" placeholder="Schüler*in suchen..." aria-label="Schüler*in suchen" />
            </div>
            <AppButton variant="muted" size="md" iconOnly aria-label="Importieren">
              <IconImport />
            </AppButton>
            <AppButton variant="muted" size="md" iconOnly aria-label="Exportieren">
              <IconExport />
            </AppButton>
            <AppButton variant="muted" size="md" iconOnly aria-label="Löschen" disabled>
              <IconDelete />
            </AppButton>
          </>
        }
      />
    ),
  },
  {
    key: "lg",
    token: "--ds-action-gap-lg",
    value: "14px",
    actionSize: "LG-Actions",
    preview: (
      <>
        <AppButton size="lg" variant="neutral">
          Abbrechen
        </AppButton>
        <AppButton size="lg" variant="primary">
          Einreichen
        </AppButton>
      </>
    ),
  },
];

function ActionGapTable() {
  return (
    <div className="ds-docs-action-gap-table" aria-label="Action Gap Tokens">
      <div className="ds-docs-action-gap-table__head">Action-Grösse</div>
      <div className="ds-docs-action-gap-table__head">Spacing-Wert</div>
      <div className="ds-docs-action-gap-table__head">Token</div>
      <div className="ds-docs-action-gap-table__head">Vorschau</div>
      {actionGapRows.map((row) => (
        <React.Fragment key={row.token}>
          <span>{row.actionSize}</span>
          <strong>{row.value}</strong>
          <code>{row.token}</code>
          <div className="ds-docs-action-gap-table__preview" style={{ "--ds-docs-action-gap": `var(${row.token})` }}>
            {row.preview}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function SpacingDocs() {
  return (
    <DocsSectionCard title="Spacing">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--spacing">
        <DocsPreviewPanel label="Action Gaps" icon={IconRules}>
          <div className="ds-docs-preview-surface ds-docs-spacing-sheet">
            <ActionGapTable />
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow
          intro="Action Gaps richten sich nach der Grösse der verwendeten Actions."
          items={[
            "Keinen generischen Action-Gap verwenden: immer xs, sm, md oder lg wählen.",
            "Page Padding und Header-Abstand kommen aus Default Layout 1.",
            "Table-, Field- und Control-Abstände kommen aus den jeweiligen Komponenten.",
          ]}
        />
      </div>
    </DocsSectionCard>
  );
}
